import "react-hot-loader/patch";
import React from "react";
import DOOM from "react-dom";
import Client from "./container";
import { loadableReady } from "@loadable/component";

const app = document.getElementById('app');

if (module.hot) {
	loadableReady(() => DOOM.render(<Client />, app))
} else {
	loadableReady(() => DOOM.render(<Client />, app))
}

if (module.hot) {
	module.hot.accept()
}

// something
